<template>

    <div id="app">
        <el-container class="flextext">
          <home-head></home-head>
          <el-main class="neitong_bufen_qiangzhi">

            <div class="content">
              <div class="small-title">
                <span class="goods_info_name">
                    {{ goods_info.name }}
                </span> 
                <span class="self-tag" >
                    自营
                </span>
              </div>
              <el-row :gutter="30">
                <el-col :xs="24" :sm="24" :md="9">
                  <div class="shop_list">
                    <el-image
                      class="shop1"
                      :src="goods_info.imageUrl"
                      fit="cover"
                    >
                      <div slot="error" class="image-slot">
                        <img
                          src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png"
                          alt=""
                          style="height: 460px; width: 460px"
                        />
                      </div>
                    </el-image>
                  </div>
                </el-col>
                <el-col :xs="24" :sm="24" :md="15">
                  
                  <div class="goods-attr" style="">

                    <div class="item">
                        <span class="title"> 分类 </span>
                        <!-- <span class="value">{{ goods_info.category_id }}</span> -->
                        <span class="value">{{ goods_info.category.name }}</span>
                    </div>
                    
                    <div class="item">
                        <span class="title"> 型号 </span>
                        <span class="value">{{ goods_info.model }}</span>
                    </div>

                  </div>
                  
                </el-col>
              </el-row>
              <div class="goods_description" style="margin-bottom: 40px;  width: 100%">
                
                <div class="title" >
                    商品详情
                </div>
                
                <div class="content" v-html="goods_info.description">
                    
                </div>
                
              </div>

              <div class="contact"  style="margin-bottom: 40px;">
                <div class="title" >
                    联系方式
                </div>
                <div class="content" >
                    <div class="item">
                        <span class="key"> 电话 </span>
                        <span class="value">{{ goods_info.contact.phone }}</span>
                    </div>
                    
                    <div class="item">
                        <span class="key"> 微信 </span>
                        <span class="value">{{ goods_info.contact.wechat }}</span>
                    </div>
                </div>
              </div>
            </div>
          </el-main>
    
    
          <footerall></footerall>
        </el-container>
    </div>

</template>

<script>

import home_head from '../../common/home-head';
import footerall from "../../common/footer";
  export default {
    name: "category",
    data: function () {
      return {
        api_url:'',
        goods_id:0,
        goods_info:{

        }
      };
    },
    components: {
        'home-head': home_head,
        footerall
    },
    methods: {
      // 导航
      init:function(){
        this.api_url = window.config.api_url;
        this.goods_id = this.$route.params.id;
        this.get_goods_info();

      },

      get_goods_info:function(){

        let url = window.config.api_url + '/college/self/goods/single/' + this.goods_id;
        var t = this;
        t.axios.get(url).then(res => {

            t.goods_info = res.data;
        })

      }

    },
  
    created() {
      this.init();
      
    },
    beforeRouteEnter(to, from, next) {
      console.log("to122", to, from);
      next();
    },
  };
</script>

<style lang="less">

.small-title{

    font-size:20px;
    margin-top: 20px;
    margin-bottom: 20px;
    line-height: 2;

    .goods_info_name{

        font-weight:bold;

    }

    .self-tag{
        color: rgb(198, 0, 0);
        border: 1px solid rgb(198, 0, 0); 
        padding: 2px 5px; 
        border-radius: 5px;
    }

}

.goods-attr{
    margin-bottom: 30px;
     margin-left: 40px;
    
    .item{

        font-size: 14px;
        line-height: 2;

        .title{
            font-weight: bold;
            display: inline-block;
            width: 60px;
            &::after{
                content: ":";
            }
        }

        .value{

        }

    }


}

.goods_description, .contact{

    padding:20px 0 ;
    .title{

        font-size:20px;
        font-weight:bold;
        border-bottom:solid 3px #4E6EF2;
        
    }

    .content{
        margin-top:20px!important;
    }


    .item{

        font-size: 14px;
        line-height: 2;

        .key{
            font-weight: bold;
            display: inline-block;
            width: 60px;
            &::after{
                content: ":";
            }
        }

        .value{

        }

    }
  }
</style>


<style>

.checked{
  background-color: #4E6EF2;
}
.checked .search-tops-title{
  color:#fff;
}
  .neitong_bufen_qiangzhi .el-tag--light {
    background-color: #4E6EF2 !important;
    color: #FFFFFF !important;
  }

  .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #4E6EF2;

  }

  .neitong_bufen_qiangzhi .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #4E6EF2;
  }

  .el-checkbox__inner {
    margin-left: -15px;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #666666 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__inner:hover {
    border-color: #666666 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #333333 !important;
  }

  .neitong_bufen_qiangzhi .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #4E6EF2 !important;
    border-color: #333333 !important;
  }

  .neitong_bufen_qiangzhi .el-cascader .el-input .el-icon-arrow-down {
    font-size: 0px !important;
    color: #666666 !important;
  }

  .jilian_xuanzeqi_wenzi_yangshi {
    font-size: 18px !important;

  }

  .neitong_bufen_qiangzhi .el-input__inner {
    border: 0px !important;
  }

  .neitong_bufen_qiangzhi .el-tag {
    text-align: center;
    width: 120px;
    margin-top: 20px;
    padding: 0;
    height: 24px;
    line-height: 24px;
    margin-left: 2.5% !important;
  }

  .el-checkbox__label {
    font-size: 18px !important;
  }

  .el-checkbox {

    font-size: 18px !important;
  }
</style>
<style lang="less" scoped>
  @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

  @head_text: Source Han Sans CN;
  @font-face {

  }

  @import "../../../assets/css/home";
  @import "../../../assets/css/home_second_goods";
  .flextext {
    display: flex;
    flex-direction: column;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;

  }
.shangpin_sousou{
  width: 430px;
}

</style>

  